<template>
  <div class="status-tab">
    <van-tabs v-if="theme === 'normal'" v-model:active="activeName" @click-tab="onClickTab">
      <van-tab title="全部计划" name="all"></van-tab>
      <van-tab
        v-for="(type, index) in Object.keys(FOLLOW_UP_TASK_TYPE)"
        :key="index"
        :title="FOLLOW_UP_TASK_TYPE[type]"
        :name="type"
      ></van-tab>
    </van-tabs>
    <div v-else class="self-status-tab" @click="onClickTab">
      <div :class="{ 'select-item': activeName === 'all' }" flag="all">全部</div>
      <div
        v-for="(type, index) in Object.keys(FOLLOW_UP_TASK_TYPE)"
        :key="index"
        :flag="type"
        :class="{ 'select-item': activeName === type }"
      >
        {{ FOLLOW_UP_TASK_TYPE[type] }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FOLLOW_UP_TASK_TYPE } from '@/constants/global';

const props = withDefaults(defineProps<{ theme?: string }>(), {
  theme: 'normal',
});

const activeName = ref('all');
const emit = defineEmits(['change']);

const onClickTab = ({ target }) => {
  if (props.theme !== 'normal') {
    const flag = target.getAttribute('flag');
    activeName.value = flag;
  }
  emit('change', activeName.value);
};
</script>

<style scoped lang="less">
.status-tab {
  position: relative;
  background: #fff;

  .self-status-tab {
    display: flex;
    padding: 24px;

    > div {
      margin-right: 16px;
      padding: 0 24px;
      border: 1px solid #f4f7fa;
      border-radius: 35px;
      height: 64px;
      background: #f4f7fa;
      line-height: 64px;
      text-align: center;
      font-size: 28px;
      color: #4e5761;
    }

    .select-item {
      border: 1px solid #0d7cff;
      background: #f2f8ff;
      font-weight: 500;
      color: #0d7cff;
    }
  }
}
</style>
